<template>
    <div v-if="isLoading" class="py-4 container-fluid p-5 text-center">
        <div class="row">
                <div class="card p-10">
                    <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                </div>
        </div>
    </div>
    <div v-else class="container-fluid py-4">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="row">
                            <div class="col-12 col-md-8">
                                <h6>Detalle de Nota de Crédito</h6>
                                <p class="text-sm mb-0">{{factura.header.invoice_type}} #{{ factura.header.full_number }}</p>
                            </div>

                            <div class="col-12 col-md-2 text-md-end mt-2 mt-md-0">
                                <argon-button
                                class="btn btn-success w-100 w-md-auto"
                                @click="printPDF"
                                size="sm"
                                >
                                <i class="fa fa-print me-1"></i>
                                Imprimir
                                </argon-button>
                            </div>

                            <div class="col-12 col-md-2 text-md-end mt-2 mt-md-0">
                                <argon-button
                                class="btn btn-success w-100 w-md-auto"
                                @click="goBack"
                                size="sm"
                                >
                                <i class="fa fa-arrow-left me-1"></i>
                                Volver
                                </argon-button>
                            </div>
                        </div>

                    </div>
                    <div class="card-body pb-2">
                        <div class="row mb-4">
                            <div class="col-md-6">
                                <h6 class="mb-2">Información de la Empresa</h6>
                                <p class="text-sm mb-1"><strong>NIT:</strong> {{ factura.header.emitter_nit }}</p>
                                <p class="text-sm mb-1"><strong>Nombre:</strong> {{ factura.header.emitter_name }}</p>
                            </div>
                            <div class="col-md-6">
                                <h6 class="mb-2">Información del Cliente</h6>
                                <p class="text-sm mb-1"><strong>NIT:</strong> {{ factura.header.client_nit }}</p>
                                <p class="text-sm mb-1"><strong>Nombre:</strong> {{ factura.header.client_name }}</p>
                                <p class="text-sm mb-1"><strong>Tipo:</strong> {{ factura.header.client_type || 'N/A' }}</p>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6">
                                <p class="text-sm mb-1"><strong>Tipo:</strong> {{ factura.header.invoice_type === 'FACTURA' ? 'Factura' : 'Ticket' }}</p>
                                <p class="text-sm mb-1"><strong>Fecha de Emisión:</strong> {{ $formatDate(factura.header.date_issued) }}</p>
                                <p class="text-sm mb-1"><strong>Moneda:</strong> {{ factura.header.currency }}</p>
                                <p class="text-sm mb-1">
                                    <strong>Estado: </strong>
                                    <span :class="getStateClass(factura.header.state)">
                                        {{ getStateText(factura.header.state) }}
                                    </span>
                                </p>
                            </div>
                            <div class="col-md-6 text-end">
                                <p class="text-sm mb-1"><strong>Serie/Número:</strong> {{ factura.header.series }}-{{ factura.header.number }}</p>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                                        <th class="text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio Unit.</th>
                                        <th class="text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-danger">Descuento</th> <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Impuesto (%)</th>
                                        <th class="text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total Línea</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(line, index) in factura.lines" :key="index">
                                        <td class="text-start">
                                            <p class="text-xs font-weight-bold mb-0">{{ line.description }}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="text-xs font-weight-bold mb-0">{{ line.quantity.toFixed(2) }}</p>
                                        </td>
                                        <td class="text-end">
                                            <p class="text-xs font-weight-bold mb-0">
                                                {{ $formatCurrency(line.unit_price,  currency, symbol) }}
                                            </p>
                                        </td>
                                        <td class="text-end text-danger"> <p class="text-xs font-weight-bold mb-0">
                                                {{ $formatCurrency(line.discount, currency, symbol) }}
                                            </p>
                                        </td>
                                        <td class="text-end">
                                            <p class="text-xs font-weight-bold mb-0">{{$formatCurrency(line.tax_rate.toFixed(2), currency, symbol) }}</p>
                                        </td>
                                        <td class="text-end">
                                            <p class="text-xs font-weight-bold mb-0">
                                                {{ $formatCurrency(line.line_total,  currency, symbol) }}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-6"></div>
                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <tbody>
                                            <tr>
                                                <td class="text-start"><strong>Subtotal Bruto:</strong></td>
                                                <td class="text-end">
                                                    {{ $formatCurrency(factura.header.sub_total_brut, currency, symbol) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-start text-danger"><strong>Descuento Total:</strong></td>
                                                <td class="text-end text-danger">
                                                    -{{ $formatCurrency(factura.header.total_discount,  currency, symbol) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-start"><strong>Subtotal Neto (Base Imp.):</strong></td>
                                                <td class="text-end">
                                                    {{ $formatCurrency(factura.header.subtotal,  currency, symbol) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-start"><strong>Impuestos:</strong></td>
                                                <td class="text-end">
                                                    {{ $formatCurrency(factura.header.total_taxes,  currency, symbol) }}
                                                </td>
                                            </tr>
                                            <tr class="font-weight-bold">
                                                <td class="text-start"><strong>Total Final:</strong></td>
                                                <td class="text-end text-success">
                                                    {{ $formatCurrency(factura.header.total,  currency, symbol) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3" v-if="factura.header.dte_json || factura.header.dte_signature">
                            <div class="col-12">
                                <h6 class="mb-2">Información DTE (Facturación Electrónica)</h6>
                                <p class="text-sm mb-1" v-if="factura.header.dte_traceability_code">
                                    <strong>Código de Rastreo:</strong> {{ factura.header.dte_traceability_code }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Importa ArgonButton si lo usas
import ArgonButton from "@/components/ArgonButton.vue";
import { useInvoicePrinter } from "@/composables/useInvoicePrinterPOS";
import { useDTEFiscal } from "@/composables/useDTEFiscal";

import { useCompanyConfig } from '@/composables/useCompanyConfig';

import axios from "axios";
export default {
    name: "factura-detail",
    components: {
        ArgonButton,
    },
    setup(){
        const { companyConfig,isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración cada vez que el componente se monte/cargue
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
    },
    data() {
        return {
            isLoading: true,
            factura:null,
            currency:'USD',
            symbol:'$'
            // Datos simulados (hardcodeados para simulación, como en tus ejemplos)
        };
    },
    watch: {
        companyConfig(newVal){
            this.currency=newVal.currency_code;
            this.symbol=newVal.currency_symbol;
        },
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'accept': '*/*',
                'Authorization':`Bearer ${token}`
            }
        };
        this.fetchInvoice(config);
    },
    methods: {
        async fecthCustomer(config){
            //console.log(this.factura.client_id);
            axios.get(`${this.$store.state.apiURL}clients/${this.factura.header.client_id}`, config)
            .then((result) => {
                const headerData = result.data;
                if (!headerData || !headerData.id) {
                    throw new Error('Factura no encontrada o datos incompletos.');
                }
                console.log(headerData);
                this.mapClientToHeader(headerData);

            })
            .catch(error => {
                console.error("Error al cargar la factura:", error.response || error);
                self.factura = null;

                // Manejo de error de autenticación/sesión
                if (error.response && error.response.status === 401) {
                    self.$swal({
                        title: 'Sesión',
                        text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                        icon:'warning',
                        showCancelButton: false,
                        confirmButtonColor:'#bf4f51',
                        showCloseButton: true,
                        showLoaderOnConfirm: false
                    }).then(function(){
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        self.$router.push('/signin');
                    });
                } else {
                    self.$swal({
                        title: 'Error de Carga',
                        text: 'Ocurrió un error al intentar cargar la factura. Revise la consola.',
                        icon: 'error'
                    });
                }
            });
        },
        mapClientToHeader(client) {
        // Utiliza el operador de fusión de nulos (??) para los valores por defecto
        this.factura.header.client_name = client?.name || 'Consumidor Final';
        this.factura.header.client_nit = client?.nit || '0000000000';
        this.factura.header.client_address = client?.fiscal_address || client?.commercial_address || 'Sin dirección';
        this.factura.header.client_nrc = client?.nrc || null;
        this.factura.header.client_document_type = client?.document_type || '36'; // 36=Consumidor Final
        this.factura.header.client_department_code = client?.department_code || null;
        this.factura.header.client_municipality_code = client?.municipality_code || null;
        this.factura.header.client_activity_code = client?.activity_code || '99999'; // 99999=Varios/CF
        this.factura.header.client_activity_desc = client?.activity_desc || 'Venta al consumidor';
        this.factura.header.client_email = client?.email || null;
        this.factura.header.client_phone=client?.phone || null;
        this.factura.header.excent=client?.excent || null;
        },
        async fetchInvoice(config){
            const self = this;
            const invoiceId = this.$route.params.id;

            if (!invoiceId) {
                self.factura = null;
                return;
            }

            // ✅ Uso directo de config como segundo argumento, siguiendo tu estilo
            axios.get(`${this.$store.state.apiURL}invoice_headers/${invoiceId}?include_lines=true`, config)
            .then((result) => {
                const headerData = result.data;
                if (!headerData || !headerData.id) {
                    throw new Error('Factura no encontrada o datos incompletos.');
                }

                // ✅ CONVERSIÓN DE TIPOS EN LAS LÍNEAS
                const processedLines = (headerData.lines || []).map(line => ({
                    ...line,
                    // Convertir campos DECIMAL/FLOAT de string a float usando parseFloat
                    quantity: parseFloat(line.quantity),
                    unit_price: parseFloat(line.unit_price),
                    discount: parseFloat(line.discount),
                    tax_rate: parseFloat(line.tax_rate),
                    line_total: parseFloat(line.line_total),
                }));

                // ✅ CONVERSIÓN DE TIPOS EN EL ENCABEZADO
                // Es esencial convertir también los totales de la cabecera
                const processedHeader = {
                    ...headerData,
                    subtotal: parseFloat(headerData.subtotal),
                    total_taxes: parseFloat(headerData.total_taxes),
                    total: parseFloat(headerData.total),
                };

                // Estructura final con números en lugar de strings
                self.factura = {
                    header: processedHeader,
                    lines: processedLines
                };
                console.log(self.factura);
                self.isLoading=false;
                this.fecthCustomer(config);
            })
            .catch(error => {
                console.error("Error al cargar la factura:", error.response || error);
                self.factura = null;

                // Manejo de error de autenticación/sesión
                if (error.response && error.response.status === 401) {
                    self.$swal({
                        title: 'Sesión',
                        text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                        icon:'warning',
                        showCancelButton: false,
                        confirmButtonColor:'#bf4f51',
                        showCloseButton: true,
                        showLoaderOnConfirm: false
                    }).then(function(){
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        self.$router.push('/signin');
                    });
                } else {
                    self.$swal({
                        title: 'Error de Carga',
                        text: 'Ocurrió un error al intentar cargar la factura. Revise la consola.',
                        icon: 'error'
                    });
                }
            });
        },
        getStateClass(state) {
            return state === 'EMITTED' ? 'text-warning' : state === 'PAID' ? 'text-success' : 'text-danger';
        },
        getStateText(state) {
            return state === 'EMITTED' ? 'Emitida' : state === 'PAID' ? 'Pagada' : 'Cancelada';
        },
        goBack() {
            this.$router.push('/invoices');  // Asumiendo que la lista está en /facturacion
        },
        async printPDF() {
            if (!this.factura || this.factura.lines.length === 0) {
                alert('No hay datos de factura para imprimir.');
                return;
            }
            console.log(this.factura.header.invoice_type);

            let formatToUse = this.companyConfig.invoice_default_format
            if(this.factura.header.invoice_type=='TICKET'){
                useInvoicePrinter(this.factura,this.companyConfig, true);
            }else{
                if (formatToUse == 3 || (formatToUse != 1 && formatToUse != 2)) {
                    const selection = await this.askForInvoiceFormat();
                    formatToUse = selection;
                }
                if (formatToUse == 1) {
                    // Formato 1: Ticket (POS)
                    useInvoicePrinter(this.factura, this.companyConfig, true);
                } else if (formatToUse == 2) {
                    // Formato 2: Legible (Carta / DTE Fiscal)
                    useDTEFiscal(this.factura, this.companyConfig, true);
                } else {
                    // Se selecciona 0 (Cancelación) o un valor no válido
                    self.$swal('Impresión Cancelada', 'No se seleccionó un formato válido.', 'info');
                }

            }
        },
        async askForInvoiceFormat() {
            const result = await this.$swal({
                title: 'Seleccione Formato de Impresión',
                text: '¿Qué formato desea utilizar para este documento?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Formato Carta (Legible)',
                cancelButtonText: 'Formato Ticket (POS)',
                reverseButtons: true,
                focusConfirm: false,
                showDenyButton: false,
                // Colores para que sea claro
                confirmButtonColor: '#17c1e8', // Info/Azul (Legible)
                cancelButtonColor: '#2dce89', // Success/Verde (Ticket)
            });

            if (result.isConfirmed) {
                // El usuario seleccionó el botón 'Confirmar' (Legible)
                return 2; // Formato Legible (Carta / DTE Fiscal)
            }
            else if (result.dismiss === this.$swal.DismissReason.cancel) {
                // El usuario seleccionó el botón 'Cancelar' (Ticket)
                return 1; // Formato Ticket (POS)
            }
            // Si el usuario cierra el modal o presiona fuera, devolvemos 0 para cancelar
            return 0;
        }
    }
};
</script>